var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-PB"},[_c('iframe',{attrs:{"title":"dispensación Savia Salud","width":"100%","height":"100%","src":"https://app.powerbi.com/view?r=eyJrIjoiY2Y0OWM5ZjMtOTFiYy00MDg2LTllZWQtMjZjNWQ0MWUyOTQ1IiwidCI6IjllMDQ0ZjE3LWM3M2MtNGU1ZC04NWViLTMyNDNlNTU1YjczOSIsImMiOjR9","frameborder":"0","allowFullScreen":"true"}})])
}]

export { render, staticRenderFns }